import { DwModalRef } from 'ng-quicksilver';
import { OnInit } from '@angular/core';
var DwExceptionComponent = /** @class */ (function () {
    function DwExceptionComponent(modalSubject) {
        this.modalSubject = modalSubject;
        this.type = '';
        this.img = '';
        this.title = '';
        this.desc = '';
        this.descDetail = [];
    }
    Object.defineProperty(DwExceptionComponent.prototype, "statusCode", {
        set: function (statusCode) {
            this.type = statusCode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DwExceptionComponent.prototype, "statusDescDetail", {
        set: function (statusDescDetail) {
            this.descDetail = statusDescDetail;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * 確定
     */
    DwExceptionComponent.prototype.emitDataOutside = function () {
        // this.modalSubject.next(this.type); // 在彈出層組件中可以通過DwModalSubject向外層組件傳出數據
        this.modalSubject.triggerOk(); // 表示銷毀模式的時候會執行用戶傳入的選項中的onCancel還是的OnOK方法
    };
    /**
     * 取消
     */
    DwExceptionComponent.prototype.handleCancel = function (e) {
        this.modalSubject.triggerCancel();
    };
    DwExceptionComponent.prototype.ngOnInit = function () {
        this.reSet();
    };
    DwExceptionComponent.prototype.reSet = function () {
        var item = ({
            400: {
                title: '400',
                desc: 'dw-http-error-400' // 錯誤的請求
            },
            401: {
                title: '401',
                desc: 'dw-http-error-401' // 發送的請求缺乏憑證
            },
            403: {
                title: '403',
                desc: 'dw-http-error-403' // 抱歉，您無權訪問該頁面
            },
            404: {
                title: '404',
                desc: 'dw-http-error-404' // 抱歉，您訪問的頁面不存在
            },
            500: {
                title: '500',
                desc: 'dw-http-error-500' // 抱歉，服務器出錯了
            },
        })[this.type];
        if (!item) {
            if (this.type) {
                this.title = this.type;
                this.desc = 'dw-http-error'; // 抱歉，出錯了
            }
            else {
                return;
            }
        }
        else {
            this.title = item.title;
            this.desc = item.desc;
        }
    };
    return DwExceptionComponent;
}());
export { DwExceptionComponent };
